import parse from "html-react-parser";

export const LOCAL_STORAGE_KEYS = {
  TOKEN_KEY: "authToken",
};

const options = {
  replace: (domNode) => {
    const extractText = (node) => {
      if (node.type === "text") {
        return node.data || "";
      } else if (node.children) {
        return node.children.map(extractText).join("");
      } else {
        return "";
      }
    };

    if (domNode.attribs && domNode.attribs.class === "remove") {
      return extractText(domNode);
    }
  },
};

export const htmlParser = (htmlString) => {
  return parse(htmlString ? `${htmlString}` : "", options);
};

export const getTextFromHTML = (htmlString) => {
  if (htmlString) {
    htmlString = htmlString.replace(/<\/(li|p|td|th|tr|div)>/g, " </$1>");
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;
    let textContent = tempDiv.textContent || tempDiv.innerText || "";
    textContent = textContent.replace(/\s+/g, " ").trim();
    return textContent;
  } else return "";
};

// export const BASE_URL = 'https://api.stg.survey-one-apis.com/api/v1';
//export const BASE_URL = 'https://api.dev.survey-one-apis.com/api/v1';
// export const BASE_URL = 'http://localhost:8080/api/v1';

// Support runtime override of API base URL for PDF generation in private VPCs
// When Gotenberg renders pages in a private VPC, it may need to use internal URLs
// that are not accessible from public internet. This allows passing an apiBaseUrl
// parameter to override the default public URL.
const getBaseUrl = () => {
  const overrideUrl = sessionStorage.getItem('apiBaseUrl');
  if (overrideUrl) {
    console.log('Using override API base URL from sessionStorage:', overrideUrl);
    return overrideUrl + "/api/v1";
  }
  return process.env.REACT_APP_BASE_URL + "/api/v1";
};

export const BASE_URL = getBaseUrl();

export const APP_URL = process.env.REACT_APP_BASE_URL;

export const USER_ROLES = {
  SURVEY_ADMIN_ROLENAME: "Survey Respondent",
  SURVEY_SUPPORT_ROLENAME: "Survey Response Support Staff",
  BUILDER_SUPER_USER_ROLENAME: "Builder Super User",
  BUILDER_ADMIN_ROLENAME: "Builder Admin",
  BUILDER_STAKEHOLDER_LEVEL_1_ROLENAME: "Stakeholder Admin Level 1",
  BUILDER_STAKEHOLDER_LEVEL_2_ROLENAME: "Stakeholder Admin Level 2",
  BUILDER_STAKEHOLDER_LEVEL_3_ROLENAME: "Stakeholder Admin Level 3",
  BUILDER_AHA_GROUP_USER_ROLENAME: "AHA Group User",
  LICENSEE_ROLENAME: "Licensee",
  MASTER_ROLENAME: "Master",
  CONTACTPOINT_ROLENAME: "Contact Point",
};
